import { HoldingClass } from 'types';

export type HoldingClassForConstitutionExcel = Pick<HoldingClass, '_id' | 'name'> & {
  numerationOption?: HoldingClass['numerationOption'];
};

export type ConstitutionNumerationState = {
  from: Record<string, number>;
  refs: Record<string, string>;
};

const resolveNumerationOptionId = (
  numerationOption: HoldingClass['numerationOption'] | undefined,
  fallbackId: string
): string => {
  if (!numerationOption) return fallbackId;
  if (typeof numerationOption === 'string') return numerationOption;
  return numerationOption._id || fallbackId;
};

export const initConstitutionNumerations = (
  holdingClasses: HoldingClassForConstitutionExcel[]
): ConstitutionNumerationState | null => {
  if (!holdingClasses?.length) return null;

  const initial = holdingClasses.reduce<{
    from: Record<string, number>;
    refs: Record<string, string>;
  }>(
    (acc, currentClass) => {
      acc.from[currentClass._id] = 1;
      acc.refs[currentClass._id] = resolveNumerationOptionId(
        currentClass.numerationOption,
        currentClass._id
      );
      return acc;
    },
    { from: {}, refs: {} }
  );

  const finalRefs = Object.entries(initial.refs).reduce<Record<string, string>>(
    (acc, [id, ref]) => {
      acc[id] = acc[initial.refs[ref]] || initial.refs[ref];
      return acc;
    },
    {}
  );

  return { from: initial.from, refs: finalRefs };
};
